<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">新增標籤</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:32|64! {p:32|24!}@<lg {p:32|16!}@<sm">
                        <div class="flex flex-wrap:wrap jc:flex-start ai:center gap:24 {gap:16}@<lg {gap:12}@<sm">
                            <div class="{b:1|solid|#CECECE;bg:#f8f8f8;color:black;f:14;r:8;p:8|12;inline-flex;gap:8;ai:center;white-space:nowrap}" :key="tag" v-for="(tag, idx) in tags">
                                <span v-text="tag"></span>
                                <button class="f:12 lh:1 inline-flex ai:center jc:center w:12 h:12" @click="remove(idx)">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                            <div class="rel flex:1 flex ai:center gap:4" v-if="tags?.length < 5">
                                <span>#</span>
                                <form class="flex:1" @submit.prevent="add">
                                    <input class="outline:none! w:full b:0" maxlength="20" placeholder="新增標籤，最多五個" type="text" v-model.trim="input" />
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-secondary" data-bs-dismiss="modal" type="button">取消</button>
                        <button class="btn btn-primary" @click="submit" :disabled="!tags?.length" type="button">確認</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const root = ref();
    const input = ref();

    const props = defineProps({
        modelValue: { required: true, type: Array }
    });

    const tags = ref();

    let modal;

    const add = () => {
        if (input.value && !tags.value.includes(input.value)) {
            tags.value.push(input.value);
        }

        input.value = "";
    };

    const emit = defineEmits(["update:modelValue"]);

    const remove = (index) => {
        tags.value.splice(index, 1);
    };

    const show = () => {
        input.value = "";
        tags.value = [...props.modelValue];

        modal.show();
    }

    const submit = () => {
        emit("update:modelValue", [...tags.value]);

        modal.hide();
    };

    defineExpose({ show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });
</script>
